import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Routes as appRoutes } from "./routes/routes";
import Navbarr from "./components/navbar";
import Footer from "./components/footer/footer";
import ScrollToTop from "./scrolltotop";
import PageLoaderWrapper from "./pageloader";
import TermsAndConditions from "./pages/termscondition";
import PrivacyPolicy from "./pages/privacypolicy";
import CancellationPolicy from "./pages/cancelpolicy";



function App() {
  return (
    <>

      <Router>
        <ScrollToTop />

        <div className=" w-full">
          <Navbarr />
        </div>
        <PageLoaderWrapper>

          <div className="App">

            <Routes>

              <Route path="/" element={<Navigate to="/home" />} />


              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cancellation-policy" element={<CancellationPolicy />} />
              {/* {appRoutes.map(({ path, element }) => (
              <Route path={path} element={element} key={path} />
            ))} */}

              {appRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element}>
                  {route.children?.map((child, childIndex) => (
                    <Route
                      key={childIndex}
                      index={child.index}
                      path={child.path}
                      element={child.element}
                    />
                  ))}
                </Route>
              ))}
            </Routes>
          </div>
        </PageLoaderWrapper>
        <Footer />
      </Router>
    </>
  );
}

export default App;
